import { Mail } from "lucide-react";

export const SupportSection = () => {
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-app-text-primary transition-colors duration-300">
        Support
      </h3>
      <div className="rounded-lg border border-app-border bg-app-surface/50 p-4 space-y-2">
        <p className="text-sm text-app-text-secondary">
          Need a feature request or need to contact support?
        </p>
        <a
          href="mailto:ninjapoplove@gmail.com"
          className="flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-colors"
        >
          <Mail className="h-4 w-4" />
          <span>ninjapoplove@gmail.com</span>
        </a>
      </div>
    </div>
  );
};
